export enum SHIFT_TYPES {
  REGULAR = 'Regular',
  SUPERVISION = 'Supervision',
}
